// Copied verbatim from eval/dashboard/internal_web/src/components/ui/LoadingState.tsx (ATM-57). Keep in step until ATM-60 shares it.
import { cn } from "../../lib/cn";

type Props = {
  /** What is loading, named: "Loading the consult…", not "Loading…". */
  label: string;
  className?: string;
};

/**
 * The first load of a view, before it has anything to hold on screen.
 *
 * The peer of `EmptyState` and `ErrorState`, and it occupies the same band as they
 * do, so a card does not resize as it moves between the three. Deliberately a
 * still, muted line and not a spinner: every scoped query keeps its previous render
 * and dims it during a refetch (`placeholderData: keepPreviousData`), so this
 * appears only when there is genuinely nothing yet — and an animation in that slot
 * draws the eye to the one place with no data in it.
 */
export default function LoadingState({ label, className }: Props) {
  return (
    <p className={cn("py-10 text-center text-sm text-ink-muted", className)} role="status">
      {label}
    </p>
  );
}
